import ApiClient from "@/api/ApiClient";

export interface Requirement {
  id: number;
  nameBd: string;
  nameClients: string;
  idWorkgroup: number;
  idCentral: number;
  type: string;
  visibleTaxi: boolean;
  visibleOperators: boolean;
  order: number;
  deleted: string | null;
}

export async function getRequirementsByWorkgroup(wgId: number) {
  const response = await ApiClient().get<Requirement[]>("reqs", { params: { wgId } });
  return response.data.sort((a, b) => {
    return a.order - b.order;
  });
}
